import { createAsyncThunk, createSlice, isPending, isRejected } from "@reduxjs/toolkit";

import {
  apiDelete,
  apiGet,
  apiPost,
  apiPut,
} from "../../../service/apiService";

const initialState = {
  Loading: false,
  resumeData: [],
  pendingCount: 0,
  completedCount: 0,
  jpResumeData: [],
  downloadResumeResponse: null
};

export const addResume = createAsyncThunk("resume/addResume", async (param, { rejectWithValue }) => {
  try {
    const response = await apiPost("resume", param, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    // throw error;
    return rejectWithValue(error);
  }
});

export const udpateResume = createAsyncThunk(
  "resume/udpateResume",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await apiPut(`resume/${id}`, formData);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getResume = createAsyncThunk(
  "resume/getResume",
  async (params, { rejectWithValue }) => {
    try {
      const {
        page,
        perPage,
        search,
        management_status,
        employeer_name,
        status,
        arrival_date,
        location,
        place
      } = params;
      const response = await apiGet(
        `resume?page=${page}&per_page=${perPage}&search=${search}&management_status=${management_status}&employeer_name=${employeer_name}&status=${status}&arrival_date=${arrival_date}&data=${params?.data ??null}&location=${location}&place=${place}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getJPResumeById = createAsyncThunk(
  "resume/getJPResumeById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiGet(`resume?resume_id=${id}&resume_version=JP`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteResume = createAsyncThunk(
  "user/deleteResume",
  async (id) => {
    try {
      const response = await apiDelete(`resume/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);


export const downloadResume = createAsyncThunk(
  "user/downloadResume",
  async (location) => {
    try {
      const response = await apiDelete(`/api/v1/download/japanese_pdf/zip?location=${location}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

const Management = createSlice({
  name: "Management",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getResume.fulfilled, (state, action) => {
        state.Loading = false;
        state.resumeData = action.payload;
        state.pendingCount = action.payload.pending;
        state.completedCount = action.payload.completed;
      })
      .addCase(downloadResume.fulfilled, (state, action) => {
        state.Loading = false;
        state.downloadResumeResponse = action.payload;
      })

      .addCase(addResume.fulfilled, (state, action) => {
        state.Loading = false;
        const newCandidate = action.payload.data;
        if (state.resumeData?.candidates) {
          state.resumeData.candidates.push(newCandidate);
        }

        // if (action.payload && action.payload.status === 201) {
        //   state.resumeData = {
        //     ...state.resumeData,
        //     candidates: [...state.resumeData.candidates, action.payload.data],
        //   };
        // }
      })

      // .addCase(deleteResume.fulfilled, (state, action) => {
      //   state.Loading = false;
      //   const deletedResumeId = action.payload.data.id;

      //   if(state.resumeData.candidates !== undefined){
      //     state.resumeData.candidates = state.resumeData.candidates.filter(
      //       (resume) => resume.id !== deletedResumeId
      //     );
      //   } else {
      //     state.resumeData.candidates = []
      //   }
      // })

      .addCase(udpateResume.fulfilled, (state, action) => {
        state.Loading = false;
        // const updateCandiate = action.payload.data;

        // state.resumeData.candidates = state.resumeData.candidates.map((user) =>
        //   user.id === updateCandiate.id ? updateCandiate : user
        // );
         const updateCandidate = action.payload.data;

  if (state.resumeData?.candidates) {
    const index = state.resumeData.candidates.findIndex(
      (user) => user.id === updateCandidate.id
    );
    if (index !== -1) {
      state.resumeData.candidates[index] = updateCandidate;
    }
  }
      }).addCase(getJPResumeById.fulfilled, (state, action) => {
        state.Loading = false;
        state.jpResumeData = action.payload;
      }).addCase(getResume.rejected, (state, action) => {
        state.Loading = false;
        console.error("Error fetching resumes:", action.error.message);
      })

      .addMatcher(
        isPending(getResume, addResume, deleteResume, udpateResume, downloadResume),
        (state) => {
          state.Loading = true;
        }
      )

      .addMatcher(
        isRejected(getResume, addResume, deleteResume, udpateResume, downloadResume),
        (state) => {
          state.Loading = false;
        }
      );
  },
});

export default Management.reducer;
